/**
 * @module geo/payload/facade
 */
import {MapOptions} from '../../types/map';

/**
 * To set new value(s) for global parameter.
 * @since v2.0.2
 * @see [[GeoApp.setGlobalParameterValue]]
 */
export class SET_GLOBAL_PARAMETER_VALUE {
  public map?: MapOptions|null;

  public id?: string;

  public name?: string;

  public values?: string|string[]|number|number[];

  public save: boolean = false;

  /**
   * @param options object with properties values
   */
  constructor(options: any) {
    Object.assign(this, options);
  }
}
